<template>
  <div class="chart">
    <canvas :id="id" class="chart-canvas" :height="height"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
export default {
  name: "HorizontalBarChart",
  props: {
    id: {
      type: String,
      default: "chart-bar",
    },
    height: {
      type: [String, Number],
      default: "300",
    },
    chart: {
      type: Object,
      required: true,
      labels: Array,
      datasets: {
        type: Array,
        label: String,
        data: Array,
      },
    },
  },
  data() {
    return {
      chartInstance: null, // Store chart instance for later destruction
    };
  },
  watch: {
    chart: {
      deep: true,
      handler(newValue, oldValue) {
        // Check if the chart data has changed
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          console.debug("Chart data has changed. Recreating chart.");

          // Destroy the old chart instance only if necessary
          if (this.chartInstance) {
            this.chartInstance.destroy();
            this.chartInstance = null; // Ensure chartInstance is reset
          }

          // Use Vue's $nextTick to ensure DOM is updated before accessing canvas
          this.$nextTick(() => {
            this.createChart();
          });
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.createChart();
    });
  },
  methods: {
    createChart() {
      console.debug("Creating chart...");
      const canvas = document.getElementById(this.id);
      // If the canvas is null, log error and return
      if (!canvas) {
        console.error(`Canvas with id "${this.id}" not found.`);
        return;
      }

      const ctx = canvas.getContext("2d");
      if (!ctx) {
        console.error("Canvas context could not be obtained.");
        return;
      }

      // Create a new chart instance
      this.chartInstance = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.chart.labels,
          datasets: [
            {
              label: this.chart.datasets[0].label,
              weight: 5,
              borderWidth: 0,
              borderRadius: 4,
              backgroundColor: "#3A416F",
              data: this.chart.datasets[0].data,
              fill: false,
            },
          ],
        },
        options: {
          indexAxis: "y",
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            y: {
              grid: {
                drawBorder: false,
                display: true,
                drawOnChartArea: true,
                drawTicks: false,
                borderDash: [5, 5],
              },
              ticks: {
                display: true,
                padding: 10,
                color: "#9ca2b7",
              },
            },
            x: {
              grid: {
                drawBorder: false,
                display: false,
                drawOnChartArea: true,
                drawTicks: true,
              },
              ticks: {
                display: true,
                color: "#9ca2b7",
                padding: 10,
              },
            },
          },
        },
      });
    },
  },
};
</script>
